import { useCoreServices } from '@bangle.io/context';
import { FunMissing, TypoCat } from '@bangle.io/ui-components';
import React from 'react';
import { NoticeView } from './notice-view';

/** Displays a notice indicating that the requested workspace could not be found, using NoticeView. */
export function WorkspaceNotFoundView({ wsName }: { wsName?: string }) {
  const coreServices = useCoreServices();

  const handleGoHome = () => {
    coreServices.navigation.goHome();
  };

  const handleCreateWorkspace = () => {
    coreServices.commandDispatcher.dispatch(
      'command::ui:create-workspace-dialog',
      null,
      'ui',
    );
  };

  return (
    <NoticeView
      title={t.app.workspaceNotFoundView.title}
      description={
        <>
          {wsName
            ? t.app.workspaceNotFoundView.description({ wsName })
            : t.app.workspaceNotFoundView.genericDescription}
          <br />
          <FunMissing />
        </>
      }
      illustration={
        <TypoCat pose="belly-up" className="mx-auto h-32 w-auto" decorative />
      }
      actions={[
        {
          label: t.app.workspaceNotFoundView.goHomeButton,
          onClick: handleGoHome,
        },
        {
          label: t.app.pageWorkspaceNotFound.createWorkspaceButton, // Reusing translation key
          variant: 'outline',
          onClick: handleCreateWorkspace,
        },
      ]}
    />
  );
}
